import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
} from '@angular/core';
import {
    ControlValueAccessor,
    FormControl,
    NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {distinctUntilChanged, map, startWith} from 'rxjs/operators';
import {BehaviorSubject, Subscription} from 'rxjs';

type propagateFn = (date: string) => void;

@Component({
    selector: 'leap-link-panel',
    templateUrl: './leap-link-panel.component.html',
    styleUrls: ['./leap-link-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: LeapLinkPanelComponent,
            multi: true,
        },
    ],
})
export class LeapLinkPanelComponent
    implements AfterViewInit, OnDestroy, ControlValueAccessor
{
    private propagateChange: propagateFn;
    leapUntilControl = new FormControl(null);
    leapIsActive$ = new BehaviorSubject<boolean>(false);
    private sub: Subscription;

    constructor() {
        this.sub = this.leapUntilControl.valueChanges
            .pipe(
                startWith(null),
                map(v => !!v)
            )
            .subscribe(v => {
                this.leapIsActive$.next(v);
            });
    }

    ngAfterViewInit() {
        this.leapUntilControl.valueChanges
            .pipe(distinctUntilChanged())
            .subscribe(value => {
                this.propagateChange(value);
            });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    registerOnChange(fn: propagateFn) {
        this.propagateChange = fn;
    }

    writeValue(value: string) {
        this.leapUntilControl.setValue(value);
    }

    registerOnTouched(fn: any) {}

    enableLeapLink() {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        this.leapUntilControl.setValue(date.toISOString());
    }

    disableLeapLink() {
        this.leapUntilControl.setValue(null);
    }
}
